import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d425c27"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map-popup" }
const _hoisted_2 = { class: "map-popup__header" }
const _hoisted_3 = {
  key: 0,
  class: "map-popup__title"
}
const _hoisted_4 = {
  key: 1,
  class: "map-popup__title"
}
const _hoisted_5 = { class: "map-popup__title-count" }

import ProfilesList from "@/mapSearch/components/MapProfiles/ProfilesList.vue";
import { PropType, computed } from "vue";
import ProfileCardInterface from "@/common/types/ProfileCardInterface";
import ArrowIcon from "@/common/icons/ArrowIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MapProfiles',
  props: {
  cards: {
    type: Array as PropType<Array<ProfileCardInterface>>,
    required: true,
  },
  visible: {
    type: Boolean,
    required: true,
  },
},
  emits: ['toggleList'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit;

const profileCountText = computed(() => {
  if (props.cards.length % 10 === 1 && props.cards.length !== 11) {
    return `${props.cards.length} анкета`
  }

  if ([2, 3, 4].includes(props.cards.length % 10)) {
    return `${props.cards.length} анкеты`
  }

  return `${props.cards.length} анкет`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (props.cards.length === 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Выберите на карте интересующие вас анкеты "))
        : (_openBlock(), _createElementBlock("p", _hoisted_4, [
            _createTextVNode(" Выбранная точка"),
            _createElementVNode("span", _hoisted_5, _toDisplayString(profileCountText.value), 1 /* TEXT */)
          ])),
      _createVNode(ArrowIcon, {
        class: _normalizeClass(["map-popup__arrow", { 'map-popup__arrow_active': __props.visible }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('toggleList')))
      }, null, 8 /* PROPS */, ["class"])
    ]),
    (__props.visible && props.cards.length)
      ? (_openBlock(), _createBlock(ProfilesList, {
          key: 0,
          cards: props.cards
        }, null, 8 /* PROPS */, ["cards"]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})